/**
 * Created by shem.mahluf on 28/08/2016.
 */
export default {
    GET_TOOLBOX_LIST: 'GET_TOOLBOX_LIST',
    TOOLBOX_LIST:'TOOLBOX_LIST'
}



// WEBPACK FOOTER //
// ./constants/toolbox.js